export default "/assets/images/app-update-img-05.png?187ba3ae722dc76b733d8dd74ebb83ef";